import { render, staticRenderFns } from "./chat-message-item.vue?vue&type=template&id=1d00c4fe&scoped=true&"
import script from "./chat-message-item.vue?vue&type=script&lang=js&"
export * from "./chat-message-item.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-item.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chat-message-item.vue?vue&type=style&index=1&id=1d00c4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00c4fe",
  null
  
)

export default component.exports